export class EventUtils {
    filter(originFn, filterFn) {
        return (...args) => {
            if (filterFn(...args)) {
                return originFn(...args);
            }
        };
    }
}
export const eventUtils = new EventUtils();
//# sourceMappingURL=EventUtils.js.map